import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top on route change
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });

    // Fire GA4 page_view hit for every SPA navigation
    trackPageView(pathname);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
